export const ESearchLocations = {
	post: { type: "post", lang: { en: "Announcements", ar: "آخر الأخبار" } },
	"explore-resources": {
		type: "explore-resources",
		lang: { en: "Parent Resources", ar: "مركز المعرفة" },
	},
	tribe_events: {
		type: "tribe_events",
		lang: { en: "Events", ar: "الفعاليات" },
	},
	page: { type: "page", lang: { en: "Links", ar: "الروابط" } },
};
